import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors}: ITheme) =>
  CreateResponsiveStyle(
    {
      safeArea: {
        flex: 1,
        backgroundColor: colors.dirtyWhite,
      },
      containerStyle: {
        flex: 1,
        alignItems: 'center',
        backgroundColor: colors.dirtyWhite,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
